import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { InvoiceAmountCalc } from '@app/core/models/invoices/invoice-amount-calc.model';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { DeductionTypeRef } from '@app/core/models/referentials/deduction-type.model';
import { NumberCommaToDotFormatPipe } from '@app/shared/pipes/number-comma-to-dot-format.pipe';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class DeductionLibraryService {
  constructor(
    private numberFormatPipe: NumberCommaToDotFormatPipe,
    private decimalPipe: DecimalPipe
  ) {}

  setAmountOnDeduction(
    index: number,
    createdAt: number,
    formControlName: string,
    InvoiceDeductions: UntypedFormArray,
    invoiceDetailModel: InvoiceDetailModel
  ) {
    let AmountProvisionedTaxExcluded = 0;
    let AmountReleasedTaxExcluded = 0;
    let AmountRetainedTaxExcluded = 0;

    var item = InvoiceDeductions.at(index) as UntypedFormGroup;
    const newValue = this.numberFormatPipe.transform(
      item.controls[formControlName].value
    );

    switch (formControlName) {
      case 'AmountProvisionedTaxExcluded':
        AmountProvisionedTaxExcluded = newValue;
        break;
      case 'AmountReleasedTaxExcluded':
        AmountReleasedTaxExcluded = newValue;
        break;
      case 'AmountRetainedTaxExcluded':
        AmountRetainedTaxExcluded = newValue;
    }
    // update Model
    var element = invoiceDetailModel.Deductions.find(
      (c) => c.CreatedAt == createdAt
    );
    element.AmountProvisionedTaxExcluded = AmountProvisionedTaxExcluded;
    element.AmountReleasedTaxExcluded = AmountReleasedTaxExcluded;
    element.AmountRetainedTaxExcluded = AmountRetainedTaxExcluded;

    // update formGroup
    item.controls.AmountProvisionedTaxExcluded.setValue(
      this.decimalPipe.transform(element.AmountProvisionedTaxExcluded, '1.2-2')
    );
    item.controls.AmountReleasedTaxExcluded.setValue(
      this.decimalPipe.transform(element.AmountReleasedTaxExcluded, '1.2-2')
    );
    item.controls.AmountRetainedTaxExcluded.setValue(
      this.decimalPipe.transform(element.AmountRetainedTaxExcluded, '1.2-2')
    );
  }

  setSumDeduction(
    invoiceDetailModel: InvoiceDetailModel,
    invoiceDetailAmountCalc: InvoiceAmountCalc,
    dataDeductionTypeAll: DeductionTypeRef[]
  ) {
    let deductionsSumProvisionedTaxExcluded = 0;
    let deductionsSumProvisionedTaxExcludedWithSign = 0;
    let deductionsSumReleasedTaxExcluded = 0;
    let deductionsSumRetainedTaxExcluded = 0;

    if (
      invoiceDetailModel.Deductions != null &&
      invoiceDetailModel.Deductions.length > 0
    ) {
      deductionsSumProvisionedTaxExcluded =
        invoiceDetailModel.Deductions.reduce<number>((accumulator, obj) => {
          return (
            accumulator +
            (!_.isNil(obj.AmountProvisionedTaxExcluded)
              ? obj.AmountProvisionedTaxExcluded
              : 0)
          );
        }, 0);

      invoiceDetailModel.Deductions.forEach((currentDeduction) => {
        if (!_.isNil(currentDeduction?.Code)) {
          let amount = !_.isNil(currentDeduction.AmountProvisionedTaxExcluded)
            ? currentDeduction.AmountProvisionedTaxExcluded
            : 0;
          const _data = _.find(
            dataDeductionTypeAll,
            (x) => x?.Code === currentDeduction?.Code
          );
          switch (_data.SignValue) {
            case '+':
              amount = amount * -1;
              break;
            default:
              break;
          }
          deductionsSumProvisionedTaxExcludedWithSign =
            deductionsSumProvisionedTaxExcludedWithSign + amount;
        }
      });

      deductionsSumReleasedTaxExcluded =
        invoiceDetailModel.Deductions.reduce<number>((accumulator, obj) => {
          return (
            accumulator +
            (!_.isNil(obj.AmountReleasedTaxExcluded)
              ? obj.AmountReleasedTaxExcluded
              : 0)
          );
        }, 0);

      deductionsSumRetainedTaxExcluded =
        invoiceDetailModel.Deductions.reduce<number>((accumulator, obj) => {
          return (
            accumulator +
            (!_.isNil(obj.AmountRetainedTaxExcluded)
              ? obj.AmountRetainedTaxExcluded
              : 0)
          );
        }, 0);
    }
    invoiceDetailAmountCalc.deductionsSumProvisionedTaxExcluded =
      this.decimalPipe.transform(deductionsSumProvisionedTaxExcluded, '1.2-2');
    invoiceDetailAmountCalc.deductionsSumReleasedTaxExcluded =
      this.decimalPipe.transform(deductionsSumReleasedTaxExcluded, '1.2-2');
    invoiceDetailAmountCalc.deductionsSumProvisionedTaxExcludedWithSign =
      this.decimalPipe.transform(
        deductionsSumProvisionedTaxExcludedWithSign,
        '1.2-2'
      );
    invoiceDetailAmountCalc.deductionsSumRetainedTaxExcluded =
      this.decimalPipe.transform(deductionsSumRetainedTaxExcluded, '1.2-2');
  }

  getAmountByPercentage(
    percentage?: number,
    invoiceAmoutIncluded?: string
  ): string {
    if (!_.isNil(percentage) && !_.isNil(invoiceAmoutIncluded)) {
      const amountTaxExcluded: number =
        this.numberFormatPipe.transformfromString(invoiceAmoutIncluded);
      const calculatedAmount = (amountTaxExcluded * percentage!) / 100;

      return this.decimalPipe.transform(calculatedAmount, '1.2-2');
    } else return '0';
  }
}
